import React from 'react';
import { isNewProductOnCatalog } from '../../../Utils/Helpers';
import { useTranslation } from 'react-i18next';

interface BadgeNewProductProps {
    product: any;
    outline?: boolean;
    className?: string;
}

const BadgeNewProduct = ({
    product,
    outline = false,
    className
}: BadgeNewProductProps) => {

    const { t } = useTranslation();

    if (!product) return null;

    const tags = Array.isArray(product.tags) ? product.tags : [];

    if (isNewProductOnCatalog(tags) && (!product.from_price || Number(product.from_price) === 0)) {
        return (
            <div className={`
                ${outline ? 'ring-1 ring-shopfood-notify text-shopfood-notify' : 'bg-shopfood-notify text-white'}
                font-black px-1.5 py-0.5 text-xs ${className}`
                }>
                {t('products.badges.new_product_label')}
            </div>
        );
    }
    return null;
};

export default BadgeNewProduct;
